import { createContext, useContext, useEffect, useState } from "react";
import toast from "react-hot-toast";

const InternetStatusContext = createContext();

export const InternetStatusProvider = ({ children }) => {
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const [toastId, setToastId] = useState(null);

  const updateStatus = () => {
    const nowOnline = navigator.onLine;
    setIsOnline(nowOnline);

    if (!nowOnline && !toastId) {
      const id = toast.error("🚫 No internet connection", {
        duration: Infinity,
      });
      setToastId(id);
    } else if (nowOnline && toastId) {
      toast.dismiss(toastId);
      setToastId(null);
      toast.success("✅ Back online");
    }
  };

  useEffect(() => {
    updateStatus(); // trigger once on mount
    window.addEventListener("online", updateStatus);
    window.addEventListener("offline", updateStatus);

    return () => {
      window.removeEventListener("online", updateStatus);
      window.removeEventListener("offline", updateStatus);
    };
  }, []);

  return (
    <InternetStatusContext.Provider value={isOnline}>
      {children}
    </InternetStatusContext.Provider>
  );
};

export const useInternetStatus = () => useContext(InternetStatusContext)